var map = {
	"./img_bg_2.jpg": 153,
	"./img_bg_3.jpg": 154,
	"./kanagu/mainImage.jpg": 155,
	"./kanagu/ourStory.jpg": 156,
	"./shashikoki/image2.jpg": 157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;